import React from "react";
import Image from "next/image";
import { FaWhatsapp, FaLinkedin, FaXTwitter } from "react-icons/fa6";

function ReachOutSection() {
  return (
    <section>
      <div className="rounded-b-semifull bg-[#E9E9EA] pb-8 xsm:pb-6 sm:pb-8 md:pb-10 lg:pb-12 xl:pb-14">
        <div className="rounded-b-semifull relative bg-[#27335D] py-14 text-white">
          {/* Intro */}
          <div className="text-center">
            <h1 className="text-3xl font-bold tracking-tight text-white md:text-4xl">
              Reach Out Anytime,{" "}
              <span className="block md:inline">Anywhere</span>
            </h1>
          </div>
          <div className="mt-6 flex flex-wrap justify-center gap-5 md:mt-12">
            <div className="z-20 flex flex-col items-center justify-center rounded-full bg-[#27335D] p-2 text-center text-xl text-white md:p-3 md:text-3xl">
              <a href="https://wa.me/966557319070" target="_blank" data-testid="reachOutWhatsappLink">
                <FaWhatsapp />
              </a>
            </div>
            <div className="z-20 flex flex-col items-center justify-center rounded-full bg-[#27335D] p-2 text-center text-xl text-white md:p-3 md:text-3xl">
              <a href="https://www.linkedin.com/company/rawiah" target="_blank" data-testid="reachOutLinkedinLink">
                <FaLinkedin />
              </a>
            </div>
            <div className="z-20 flex flex-col items-center justify-center rounded-full bg-[#27335D] p-2 text-center text-xl text-white md:p-3 md:text-3xl">
              <a href="https://x.com/rawiah_ar" target="_blank" data-testid="reachOutTwitterLink">
                <FaXTwitter />
              </a>
            </div>
            <div className="absolute bottom-[46.5%] right-[5%] translate-y-1/2 transform">
              <Image
                src="/images/svg/line5.svg"
                alt="Line"
                width={120}
                height={120}
                className="z-10 h-12 w-auto object-contain sm:h-14 md:h-20 lg:h-32"
              />
            </div>
            <div className="absolute bottom-[45%] left-[3%] translate-y-1/2 transform">
              <Image
                src="/images/svg/line6.svg"
                alt="Line"
                width={130}
                height={130}
                className="z-10 h-12 w-auto object-contain sm:h-14 md:h-20 lg:h-32"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ReachOutSection;
